export default "__VITE_ASSET__7fc816f2__"